export default "__VITE_ASSET__33d5f8f9__"